<template>
  <div class="content-page">
    <div class="main-page">
      <div class="zxfy-titie"></div>
      <div class="main-contentBox" v-loading="main_loading" element-loading-text="加载中...">
        <!-- 状态条未收案的 -->
        <div class="my-step-box" v-if="searchType == 1">
          <div class="common step-1 success" :style="`border-color:${statusInfo.color};color:${statusInfo.color}`">
            <div class="bar"></div>
            {{ statusInfo.text }}
          </div>
          <div :class="modifyStatus == '0'?'common step-2':modifyStatus == '1'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            {{modifyStatus == '2'?'补正完成': '补正中'}}
          </div>
          <div :class="hasSlsc != '1'?'common step-3':status == '3'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            已受理，审查中
          </div>
          <div :class="status == '4'?'common step-4 success':'common step-4'">
            {{status != '4'?'已办结': caseStatusText}}
          </div>
        </div>
        <!--    状态条 之前案件的    -->
        <div class="my-step-box" v-else>
          <div class="common step-1 success">
            <div class="bar"></div>
            已提交
          </div>
          <div :class="modifyStatus == '0'?'common step-2':modifyStatus == '1'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            {{modifyStatus == '2'?'补正完成': '补正中'}}
          </div>
          <div :class="hasSlsc != '1'?'common step-3':status == '3'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            已受理，审查中
          </div>
          <div :class="status == '4'?'common step-4 success':'common step-4'">
            {{status != '4'?'已办结': caseStatusText}}
          </div>
        </div>
        <div class="star-title">

        </div>
        <div>
          <div class="search-items search title-no number">
            <div class="title-no-left">
              <div class="search-item">
                <div class="search-label" style="width: 100px">
                  申请编号：
                </div>
                <div>{{ detailInfo.inquireNo || '' }}</div>
              </div>
              <div class="search-item" v-if="searchType != 1">
                <div class="search-label" style="width: 100px">
                  案号：
                </div>
                <div>{{ caseInfo.caseNo || '' }}</div>
              </div>
              <div class="search-item" v-if="modifyStatus != 0 && caseInfo.tcEndTime">
                <div class="search-label" style="width: 100px">
                  到达时间：
                </div>
                <div>{{caseInfo.tcEndTime}}</div>
              </div>
              <div class="search-item" v-if="modifyStatus == 0 && caseInfo.createTime">
                <div class="search-label">
                  到达时间：
                </div>
                <div>{{caseInfo.createTime}}</div>
              </div>
<!--              <div class="search-item" v-if="!caseInfo.tcEndTime && (caseInfo.caseSource !=3 || caseInfo.caseSource !=4)">-->
<!--                <div class="search-label" style="width: 100px">-->
<!--                  提交时间：-->
<!--                </div>-->
<!--                <div>{{caseInfo.createTime}}</div>-->
<!--              </div>-->
              <div v-if="caseInfo.withdrawTime" class="search-item">
                <div class="search-label">
                  申请撤回时间：
                </div>
                <div>{{ caseInfo.withdrawTime  }}</div>
              </div>
              <div class="search-item" v-if="caseInfo.giveBackReason">
                <div class="search-label" style="width: 100px">
                  退回原因：
                </div>
                <div>{{ caseInfo.giveBackReason || '' }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-alert
          :title="`复议申请内容以申请人提交的复议申请书为准，以上内容为对复议申请的摘录，仅供参考。如有疑问，请致电${orgPhone }。`"
          :closable="false"
          show-icon
          type="info">
        </el-alert>
        <div class="star-title">
          <span class="star"></span>申请人信息（摘要）
        </div>
        <div class="addPerson">
          <div class="addPerson-btn" v-if="applicantInfo[0].applicantCategory == 1"> 个人（{{ applicantInfo.length }}）</div>
          <div class="addPerson-btn" v-else> 法人（{{ applicantInfo.length }}） </div>
        </div>
        <!-- 申请人 -->
        <div class="form-common">
          <div v-for="(item, index) in applicantInfo" :key="index" class="appinfo-box">
            <div class="typeTitle">
              <div class="typeTitle-name"> {{ item.applicantCategory == '1' ? '个人' : '法人' }} </div>
            </div>
            <div class="search-items applicat-search-items">
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />{{ item.applicantCategory == '1' ? '姓名：' : '单位名称：' }}
                </div>
                <el-tooltip :content="item.applicantName" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.applicantName || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />性别：</div>
                <span v-if="item.gender == 0">女</span>
                <span v-else-if="item.gender == 1">男</span>
                <span v-else>未知</span>
              </div>
               <div class="search-item col1-3" v-show="item.applicantCategory == '2'">
                <div class="search-label"><i class="i-required" />社会信用代码</div>
                <el-tooltip :content="item.socialUnifiedCreditCode" class="column-content" effect="light"
                  placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.socialUnifiedCreditCode || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '2'">
                <div class="search-label"><i class="i-required" />法人代表：</div>
                <el-tooltip :content="item.legalRepresentative" class="column-content" effect="light"
                  placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.legalRepresentative || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '2'" v-for="(fileI, findex) in item.fileListJpgfR" :key="findex">
                <div class="search-label" style="width: 140px;line-height: 16px"><i class="i-required" />营业执照或其他证件材料 (图片)：</div>
                <el-tooltip :content="fileI.name" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText" style="width:50%">
                    {{ fileI.name || '' }}
                  </div>
                </el-tooltip>
                <span class="download-btn download-btn1" @click="downLoad(fileI)"> 下载 </span>
                <span @click="handlePreview(fileI)" class="download-btn"> 预览 </span>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />国家：</div>
                <span class="contry">{{ item.countryName }}</span>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />证件类型：</div>
                <span class="Identification">{{ item.identificationTypeName }}</span>
              </div>
              <div class="search-item col1-3 phone" v-if="item.applicantCategory == '2'">
                <div class="search-label">联系人：</div>
                <span class=" landline">{{ item.contactName }}</span>
              </div>
              <div v-if="item.applicantCategory == '2'" class="search-item col1-3 phoneNumber">
                <div class="search-label"><i class="i-required" />联系人手机号码：</div>
                {{ item.phone }}
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />{{ item.appplicantCategory == '1'?'证件号码：': '联系人证件号码' }}</div>
                <span class="Identification">{{ item.identificationCard }}</span>
              </div>
              <div class="search-item col1-3" v-for="(fileI, findex) in item.fileListJpg2" :key="findex">
                <div class="search-label"><i class="i-required" />身份证人像面</div>
                <el-tooltip :content="fileI.name" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText" style="width:50%">
                    {{ fileI.name || '' }}
                  </div>
                </el-tooltip>
                <span class="download-btn download-btn1" @click="downLoad(fileI)"> 下载 </span>
                <span @click="handlePreview(fileI)" class="download-btn"> 预览 </span>
              </div>
              <div class="search-item col1-3" v-for="(fileI, findex) in item.fileListJpg" :key="findex">
                <div class="search-label"><i class="i-required" />身份证国徽面</div>
                <el-tooltip :content="fileI.name" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText" style="width:50%">
                    {{ fileI.name || '' }}
                  </div>
                </el-tooltip>
                <span class="download-btn download-btn1" @click="downLoad(fileI)"> 下载 </span>
                <span @click="handlePreview(fileI)" class="download-btn"> 预览 </span>
              </div>

              <div class="search-item col1-3 birthday" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />出生日期：</div>
                {{ $moment(item.birthday).format('YYYY年MM月DD日') }}
              </div>
              <div v-if="item.applicantCategory == '1'" class="search-item col1-3">
                <div class="search-label"><i class="i-required" />手机号码：</div>
                {{ item.phone }}
              </div>


              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />文书送达地址：</div>
                <el-tooltip :content="item.deliveryArea + item.addr" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.deliveryArea || '' }}{{ item.addr || '' }}
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <!-- 被申请人信息 -->
        <div class="star-title">
          <span class="star"></span>被申请人信息（摘要）
        </div>
        <div class="search-items info">

          <div class="search-item ">
            <div class="search-label">
              <i class="i-required" />被申请人信息：
            </div>
            <div class="respondentInfo-box">
              <div v-for="(item, index) in respondentInfo" :key="index">
                <span>{{ item.respondentName }} </span>
                <span v-show="index !== respondentInfo.length - 1">、</span>
              </div>
            </div>
          </div>

          <div class="search-item col1-1">
            <div class="search-label">
              <i class="i-required" />复议机关：
            </div>
            {{ applyInfo.reconsiderationAgencyName }}
          </div>

        </div>
        <!-- 行政复议请求 -->
        <div class="star-title">
          <span class="star"></span>行政复议请求（摘要）
        </div>
        <div class=" search-items search">
          <div class="search-item ">
            <div class="search-label">请求类型：
            </div>
            {{ applyInfo.actCategory === '1' ? '不服行政不作为' : '不服具体行政行为' }}
            <span v-show="applyInfo.specificActType && applyInfo.actCategory === '2'" style="marginLeft:15px">
              {{ applyInfo.specificActType === '1' ? '请求撤销具体行政行为' : '请求确认具体行政行为违法' }}
            </span>
          </div>
          <div class="search-item" v-show="applyInfo.actCategory === '2'">
            <div class="search-label">行政行为文书名称：
            </div>
            {{ applyInfo.actName }}
          </div>
          <div class="search-item" v-show="applyInfo.actCategory === '2'">
            <div class="search-label">行政行为文号：
            </div>
            {{ applyInfo.actDocumentNo }}
          </div>
          <div class="search-item" v-show="applyInfo.actCategory === '2'">
            <div class="search-label">行政行为做出时间：
            </div>
            {{ applyInfo.actDecisionDate }}
          </div>

          <div class="search-item">
            <div class="search-label">请求内容：
            </div>
            {{ applyInfo.applyType }}
          </div>
        </div>
        <!-- 事实和理由 -->
        <div class="star-title reason">
          <span class="star"></span>事实和理由（摘要）
        </div>
        <div class=" search-items search">
          <div class="search-item">
            <div class="search-label">
              事实和理由：
            </div>
            {{ applyInfo.factsAndReasons }}
          </div>
        </div>
        <!-- 证据材料 -->
        <div class="star-title">
          <span class="star"></span>证据材料
        </div>
        <div class="search-items search ">
          <div class="search-item zhengjuBigbox">
            <div class="search-label">
              提交相关具体材料：
            </div>
            <div class="fileList cailiao">
              <div v-for="(item, index) in specFileList" :key="index" class="fileList-item">
                <el-tooltip class="fileList-itemText" effect="light" :content="item.originName || item.evidenceName" placement="top-start">
                  <span class="zhengju">{{ item.originName || item.evidenceName }}</span>
                </el-tooltip>
                <div @click="downLoad(item,'zjcl')" class="download-btn download-btn1">
                  下载
                </div>
                <div
                  v-if="item.evidenceType !== 'wav' && item.evidenceType !== 'rar' && item.evidenceType !== 'aiff' && item.evidenceType !== 'pcm' && item.evidenceType !== 'flac' && item.evidenceType !== 'alac' && item.evidenceType !== 'wma' && item.evidenceType !== 'mp3' && item.evidenceType !== 'ogg' && item.evidenceType !== 'aac' && item.evidenceType !== 'xlsx'"
                  @click="handlePreview(item,'zjcl')" class="download-btn">
                  预览
                </div>
                <div v-else class="kong-btn" />
              </div>
            </div>
          </div>
          <!-- 补正理由 -->
          <div class="star-title" v-if="inquireInfo.correctionReason">
            <span class="star" />相关补正说明（摘要）
          </div>
          <div v-if="inquireInfo.correctionReason">
            {{ inquireInfo.correctionReason }}
          </div>
        </div>
        <div class="star-title">
          <span class="star"></span>历史申请文书（摘要）
        </div>
        <div class="fileList cailiao" v-if="historyList.length > 0">
          <div v-for="(item, index) in historyList" :key="index" class="fileList-item">
            <el-tooltip class="fileList-itemText" effect="light" :content="item.evidenceName" placement="top-start">
              <span class="zhengju">{{ item.evidenceName }}</span>
            </el-tooltip>
            <div @click="downLoad(item)" class="download-btn download-btn1">
              下载
            </div>
            <div
              v-if="item.showType !== 'wav' && item.showType !== 'rar' && item.showType !== 'txt' && item.showType !== 'aiff' && item.showType !== 'pcm' && item.showType !== 'flac' && item.showType !== 'alac' && item.showType !== 'wma' && item.showType !== 'mp3' && item.showType !== 'ogg' && item.showType !== 'aac'"
              @click="handlePreview(item)" class="download-btn">
              预览
            </div>
            <div v-else class="kong-btn" />
          </div>
        </div>
        <div v-else>暂无历史文书</div>
        <div class="btnLists">
          <div v-if="oprate == 'revokeApply' && isRevoke == 1" class="primary-btn" @click="revoke()">撤回</div>
          <!-- <div v-if="indexofStr(caseInfo.caseTips,'ajibzz') > -1 && oprate == 'search'" class="primary-btn" @click="corrent()">复议申请补正</div> -->
          <div class="primary-btn" @click="back">返回上一页</div>
        </div>
      </div>
    </div>
    <dialogPreview :applicantInfo="applicantInfo" ref="dialogPreview" />
    <revokeTip :caseOrderNo="caseOrderNo" :inquireNo="detailInfo.inquireNo" :applicantInfo="applicantInfo" ref="revokeTip"
      @openCh="openCh" />
    <!--   撤回书预览   -->
    <el-dialog style="height: 80vh" v-if="fileReviewDialog" :visible.sync="fileReviewDialog" title="撤回书预览" :close-on-click-modal="false" :show-close="true">
      <span style="z-index: 999;background: #fff;text-align: right;display: flex;justify-content: flex-end">
          <el-button type="primary" @click="closeFileReviewDialog">取消</el-button>
          <el-button type="primary" @click="showConfirmDialog">下一步</el-button>
        </span>
      <div style="max-height: 80%; overflow-y: auto" v-loading="loading">
        <img v-for="(item,index) in imgList" :key="index" :src="item.fileBaseUri" />
      </div>
    </el-dialog>
    <!--   确认撤回弹窗   -->
    <el-dialog
      :visible.sync="confirmDialog"
      width="400px"
      :close-on-click-modal="false"
      :show-close="false"
      class="confirm-revoke-dialog"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">撤回</div>
      <div class="dialog-content">
        <div class="dialog-content-title">提示:</div>
        是否确认撤回申请书无误
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="gotoFaceId">
          {{ detailInfo.caseInfo && detailInfo.caseInfo.caseStatus === 0 ? '签名' : '人脸识别并签名' }}
        </el-button>
        <el-button type="primary" @click="back_prev">返回上一页</el-button>

      </div>
    </el-dialog>
    <faceIdTip ref="faceIdTip" :applicantInfo="applicantInfo" @nextTep="nextTep" />
    <singDialog ref="singDialog" signType="revoke" :opera="1" :detailInfo="detailInfo" @signature-submit="signatureSubmit" />
  </div>
</template>

<script>
import Api from '@api/api'
import dialogPreview from '@/components/dialogPreview/dialogPreview'
import revokeTip from './components/revokeTip'
import faceIdTip from '@/components/face/faceIdTip'
import singDialog from '@/components/singDialog/singDialog'
const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1';
      break;
    case 'search':
      return '2';
      break;
    case 'revokeApply':
      return '3';
      break;
  }
}
export default {
  components: {
    dialogPreview,
    revokeTip,
    faceIdTip,
    singDialog
  },
  computed: {
    statusInfo () {
      switch (this.caseInfo.caseStatus) {
        case '15': case 15:
          return {
            text: '已确认撤回',
            color: 'green'
          }
          break;
        case '9': case 9:
          return {
            text: '已退回',
            color: '#afa3a3'
          }
          break;
        case '12': case 12:
          return {
            text: '合并至已收案件',
            color: 'green'
          }
          break;
        default:
          return {
            text: '已提交',
            color: 'green'
          }
          break;
      }
      return this.$store.state.options.optionReconsiderItem
    }
  },
  watch: {
    writList: function(newVal){
      if (newVal) {
        newVal.map(item => {
          item.fileBaseUri = "data:image/png;base64," + item.fileBaseUri
        })
        this.imgList = newVal
      }
    },
  },
  data () {
    return {
      oprate: localStorage.getItem('oprate') || '',
      isRevoke: this.$route.query.isRevoke || '',
      searchType: this.$route.query.searchType || '0', // 分辨案件信息的字段 1 已申请未收案的 0 其他
      from: this.$route.query.from || '',
      imgList:[],
      detailInfo: {},
      applicantInfo: [
        {
          id: '',
          applicantCategory: '2',
          applicantName: '',
          gender: '',
          country: '',
          identificationType: '',
          identificationCard: '',
          identificationFile: '',
          bornDate: '',
          phone: '',
          telephone: '',
          addr: '',
          postcode: '',
          deliveryAddr: '',
          deliveryPostcode: '',
          sort: 1
        }
      ],
      respondentInfo: {},
      inquireInfo: {
        applyTime: ''
      },
      hasSlsc: '',
      applyInfo: {},
      number: '',
      password: '', // 新建页面带过来 存在cookie中
      rePassword: '', // 接口返回 查询页直接进入
      countGR: 0,
      countFR: 0,
      status: 0,
      modifyStatus: 0, //补正中状态 0-没有补正 1-正在补正中 2-补正中完成: 0,
      caseStatusText: '', // 案件状态（0未接收 2补正中 4已处理 5已撤回 9已退回）
      fileList1: [],
      fileList2: [],
      caseOrderNo: '',
      caseInfo: {},
      fileReviewDialog:false,
      confirmDialog: false, // 人脸识别提示弹窗
      writList:[],
      specFileList:[],
      historyList:[],
      main_loading: false,
      isSign: false // 是否签名完成了
    }
  },
  mounted () {
    this.detail()
  },
  destroyed () {
    // 页面销毁密码
    // this.$cookie.remove('LoginPass') //补正跳转需要查看详情
  },
  methods: {
    back() {
      if (this.from == 'list') {
        let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
        this.$router.replace({
          name: 'caselist',
          query: {
            phone: applicantInfo ? applicantInfo.phone : '',
            loginName: applicantInfo ? applicantInfo.loginName : '',
            identificationCard: applicantInfo ? applicantInfo.identificationCard : '',
            applicantCategory: applicantInfo ? applicantInfo.applicantCategory : ''
          }
        })
      } else {
        // this.$router.push('/register')
        let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
        if(this.status == 1 || this.status == 0 ){
           this.$router.push('/register')
        } else {
          this.$router.replace({
          name: 'caselist',
          query: {
            phone: applicantInfo ? applicantInfo.phone : '',
            loginName: applicantInfo ? applicantInfo.loginName : '',
            identificationCard: applicantInfo ? applicantInfo.identificationCard : '',
            applicantCategory: applicantInfo ? applicantInfo.applicantCategory : ''
          }
        })
        }

      }
    },
    indexofStr(str1, str2){
      return str1 ? str1.indexOf(str2) : -1
    },
    closeFileReviewDialog () {
      this.fileReviewDialog = false;
      this.isSign = false; // 返回后要重新签名
    },
    // 显示确认弹窗
    showConfirmDialog() {
      if (!this.isSign) {
      this.confirmDialog = true;
      this.fileReviewDialog = false;
      } else {
        this.doSubmit();
      }
    },
    back_prev () {
      this.confirmDialog = false;
      this.fileReviewDialog = true;
      this.isSign = false; // 返回后要重新签名
    },
    // 人脸识别
    gotoFaceId () {
      // 当案件状态为0（未收案）时，跳过人脸识别，直接签名
      if (this.detailInfo.caseInfo && this.detailInfo.caseInfo.caseStatus === 0) {
        this.confirmDialog = false;
        this.nextTep();
      } else {
        this.$refs.faceIdTip.open()
        this.confirmDialog = false;
      }
    },
    // 撤回
    doSubmit(){
      this.confirmDialog = false
      // 打开是否签名询问弹窗，再进行撤回
      let loading = this.$loading({
        Lock: true,
        text: '处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const withdrawSource = +this.$route.query.searchType + 1
      Api.revoke({
        caseSource: 4,
        caseOrderNo: this.caseOrderNo,
        inquireNo: withdrawSource === 2 ? this.detailInfo.inquireNo : '',
        withdrawSource
      }).then(({ data }) => {
        this.fileReviewDialog = false
        if (data.code == 0) {
          this.$alert('您已确认撤回申请，后续将由工作人员进行确认，您可以通过"我要查询"模块查询案件进展', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.back()
            }
          })
        }
      }).finally(() => {
        loading.close()
        loading = null
      })
    },
    // 签名
    nextTep () {
      this.$refs.singDialog.open();
    },
    // 签名确认提交
    signatureSubmit (event) {
      console.log(event);
      this.fileReviewDialog = true;
      this.$nextTick(() => {
        this.writList = event.data.data.showImgPathList
      })
      this.isSign = true; // 已签名
    },
    openCh(data){
      console.log(data)
      this.fileReviewDialog = true
      console.log( data.data.showImgPathList)
      this.writList = data.data.showImgPathList
    },
    corrent () {
      this.$router.push({
        name: 'NewCase',
        query: {
          number: this.number,
          opera: 1,
          name: 'DetailCase'
        }
      })
    },
    revoke () {
      if (this.searchType == 1) {
         if (this.applicantInfo.length > 1) {
          return this.$toast('涉及多申请人的案件，请线下提交撤回，如有疑问请于复议机构联系')
        }
        // this.$refs.revokeTip.open(this.searchType)
        // return
        let message = `现经沟通协商，申请人${ this.applicantInfo[0].applicantName }自愿撤回本行政复议申请，请予准许。`
        this.$confirm(message, '特别事项提醒', {
          confirmButtonText: '申请撤回',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          const withdrawSource = +this.$route.query.searchType + 1
          Api.revoke({
            inquireNo: this.inquireNo,
            caseSource: 4,
            caseOrderNo: this.caseOrderNo,
            withdrawSource
          }).then(({ data }) => {
            this.fileReviewDialog = false
            if (data.code == 0){
              this.$alert('您已确认撤回申请，后续将由工作人员进行确认，您可以通过"我要查询"模块查询案件进展', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.back()
                }
              });
            }
          })
        })
        .catch(() => {
          // on cancel
        });
        return;
      }
      if (this.applicantInfo.length > 1) {
        return this.$message.warning('涉及多申请人的案件，请线下提交撤回，如有疑问请于复议机构联系')
      }
      this.$refs.revokeTip.open(this.searchType)
    },
    refreshDetail () {
      this.detail()
    },
    // 获取详情
    detail () {
      this.number = this.$route.query.number

      this.fileList1 = []
      this.fileList2 = []
      const p = {
        moduleCode: moduleCodeSwitch(),
        caseOrderNo: this.number // 查询编码
      }
      if (this.searchType == 1) {
        p.searchType = 1
      }
      this.main_loading = true;
      Api.detail(p).then(res => {
        if (res.data.code === '0') {
          this.main_loading = false;
          const data = res.data.data
          // 处理一申请人个人信息
          if (data.applicantInfoList.length) {
            data.applicantInfoList.map(item => {
              item.genderName = item.gender == '1' ? '男' : '女'
              item.fileListJpg = []
              item.fileListJpg2 = []
              if(item.applicantCategory == '2'){
                item.identificationCard = item.contactIdentificationCard
              }
              item.fileListJpgfR = []
              const evidenceVoList = item.evidenceVoList || []
              evidenceVoList.forEach(img => {
                if (img.kindType == '3' ) {
                  console.log(img)
                  item.fileListJpg.push({
                    evidenceName: img.evidenceName,
                    name: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.evidenceId,
                    url: img.evidencePath,
                    showPath: img.showPath,
                    showType: img.showType,
                    kindType: 3,
                    isHistory: true,
                    ...img
                  })
                } else if(img.kindType == '0' ){
                  item.fileListJpgfR.push({
                    evidenceName: img.evidenceName,
                    name: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.evidenceId,
                    url: img.evidencePath,
                    showPath: img.showPath,
                    showType: img.showType,
                    kindType: 0,
                    isHistory: true,
                    ...img
                  })
                } else {
                  item.fileListJpg2.push({
                    evidenceName: img.evidenceName,
                    name: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.evidenceId,
                    url: img.evidencePath,
                    showPath: img.showPath,
                    showType: img.showType,
                    kindType: 4,
                    isHistory: true,
                    ...img
                  })
                }
              })
            })
          }

          let specFileList = []
          let historyList = []
          const evidence = data.evidenceList || []
          for (let i = 0; i < evidence.length; i++) {
            //type=9的附件为 行政复议申请书
            if (evidence[i].kindType === 9 || evidence[i].kindType === 7 ) {
              const applyBook = evidence[i]
              this.applyBook = applyBook
              historyList.push(applyBook)
              continue
            } else {
              specFileList.push(evidence[i])
            }
          }
          this.historyList = historyList
          this.specFileList = specFileList
          this.applicantInfo = data.applicantInfoList
          this.caseInfo = data.caseInfo
          this.applyInfo = data.caseApplyDetail
          this.respondentInfo = data.respondentInfoList
          this.status = data.wssqCaseStatus
          this.inquireNo = data.inquireNo
          this.hasSlsc = data.hasSlsc || ''
          const caseTips = data.caseInfo.caseTips || ''
          let modifyStatus = 0
          if (caseTips.includes('ajibzz')) {
            modifyStatus = 1
          }
          if (caseTips.includes('ajbz')) {
            modifyStatus = 2
          }
          this.modifyStatus = modifyStatus
          this.caseStatusText = data.wssqCaseStatusName
          this.caseOrderNo = data.caseInfo.caseOrderNo
          this.orgPhone = data.orgPhone
          this.detailInfo = data
        } else {
          this.$router.push('/codeSearch')
        }
      })
      .finally(() => {
        this.main_loading = false;
      })
    },
    // 身份证图片下载
    downLoad (item, model) {
      const p = {
        evidenceName: item.evidenceName,
        evidenceId: item.id,
        caseOrderNo: item.caseOrderNo,
        evidencePath: item.evidencePath
      }
      console.log(p)
      Api.downloadFile(p).then((res) => {
        console.log(res)
        const fileName = decodeURI(res.headers['content-disposition'].split('=')[1])
        this.downLoadFile(fileName, res.data)
      })
    },
    // 文件下载
    downLoadFile (fileName, content) {
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, fileName)
      } else { // for Non-IE (chrome, firefox etc.)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = fileName
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    // 预览
    handlePreview (item,model) {
      console.log(item, window.g.fileUrl)
      item.url =  item.originPath || item.showPath.includes('https://landing.iflysec.com:443') ? item.showPath.replace("https://landing.iflysec.com:443", "http://172.31.243.74:88") : item.showPath
      let URL = item.url
      const p = {
        evidencePath:  URL,
        evidenceType: item.evidenceType,
        evidenceName: item.evidenceName
      }
      console.log(p)
      this.$refs.dialogPreview.open(p)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .fileList2{
    margin-top: 60px !important;
  }
  .zhengjuBigbox{
    width: 100% !important;
    .zhengju {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  }
  .main-contentBox .form-common .appinfo-box .applicat-search-items {
    padding: 20px 14px 20px 30px !important;
  }

  .contry {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .Identification {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .number .search-label {
    width: 80px !important;
  }

  .landline {
    margin-left: -15px;
  }

  .phoneNumber {
    margin-top: 40px;
  }

  .zxfy-titie {
    height: 60px !important;
    background-size: 180% 100% !important;
    background-position: center !important;
  }

  .main-contentBox {
    padding: 4px 10px 15px !important;
  }

  .search-label {
    text-align: left !important;
    margin-left: 20px !important
    // width: 80px !important;
  }

  .appinfo-box .col1-3 {
    width: 90%
  }

  .form-common .search-label {
    width: 130px !important;
    margin-left: 0 !important;
  }

  .download-btn {
    width: 80px !important;
    position: absolute !important;
    top: 200;
    margin-top: 45px;
    margin-left: -5px !important;
  }

  .download-btn1 {
    width: 80px !important;
    position: absolute !important;
    top: 100;
    margin-left: 80px !important;
  }

  .birthday {
    margin-top: 45px;
  }

  .phone {
    margin-left: 15px;
  }

  .dp-dialog {
    width: 300px !important;

    .el-dialog {
      width: 300px !important;
    }
  }

  .el-dialog__wrapper {
    margin: auto;
  }

  .info .search-label {
    width: 120px !important;
    margin-bottom: 10px;
  }

  .reason .search-label {
    width: 120px !important;

  }

  .evidence {
    position: relative;

    .search-label {
      width: 140px !important;
    }

    //  .download-btn{
    //   position: absolute;
    //   top: -10px !important;
    //   left: 8px;
    //   }
  }

  .science .search-label {
    margin-top: 30px !important;
  }

  .fileList {
    // position: absolute;
    margin-left: -160px !important;
    margin-top: 40px;
    left: 20px;
    width: 80% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }

    .download-btn {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -230px !important;
    }

    .download-btn1 {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -50px !important;
    }

    // margin-left: -100px;

  }

  .cailiao {
    width: 100%;
    min-height: 20px !important;
    // background-color: pink;
  }

  .other {
    margin-top: -20px;
    width: 100% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;
      margin-top: 10px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }
  }
}

.zxfy-titie {
  background: url('~@/assets/images/zxfy-titie.png') no-repeat;
  height: 100px;
  background-size: 100% 100%;
}

.main-contentBox {
  background: linear-gradient(180deg, #FFFFFF 0%, #F5F8FE 100%);
  box-shadow: 5px 5px 20px 5px rgba(195, 195, 195, 0.09);
  padding: 20px 100px 60px;
  font-size: 14px;

  .star-title {
    margin-top: 30px;
    margin-bottom: 25px;
  }

  .addPerson {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;

    .addPerson-btn {
      width: 81px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: rgba(90, 137, 253, 0.08);
      border-radius: 4px;
      font-size: 14px;
      border: 1px solid rgba(90, 137, 253, 0.25);
      margin-right: 15px;
    }
  }

  .my-step-box {
    margin-top: 20px;
    display: flex;
      justify-content: space-between;
    align-items: center;
  }

  .my-step-box .common {
    /* margin:10px; */
    background: #ffffff;
    border: 2px solid #468cd8;
    border-radius: 10px;
    color: #468cd8;
    padding: 5px;
    position: relative;
    max-width: 150px;
    text-align: center;
    font-size: 16px;
  }

  .my-step-box .step-2 {
    border: 2px dashed #d7d7d7;
    color: #d7d7d7;
  }

  .my-step-box .step-3 {
    border: 2px dashed #d7d7d7;
    color: #d7d7d7;
  }

  .my-step-box .step-4 {
    border: 2px solid #d7d7d7;
    border-radius: 28px;
    color: #d7d7d7;
  }

  .my-step-box .active {
    border: 2px dashed #468cd8;
    border-radius: 10px;
    color: #468cd8;
  }

  .my-step-box .success {
    border-color: green;
    color: green;
  }

  .my-step-box .bar {
    position: absolute;
    right: -350px;
    top: 50%;
    width: 340px;
    height: 1px;
    border-top: 1px solid #4a5b9b;
  }

  .form-common {
    .appinfo-box {
      background: rgba(90, 137, 253, 0.02);
      box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
      border-radius: 0px 0px 4px 4px;
      backdrop-filter: blur(20px);
      margin-top: 24px;

      .typeTitle {
        background: url('~@/assets/images/applytitle.png') no-repeat;
        width: 100%;
        height: 52px;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;

        .typeTitle-name {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #333333;
          line-height: 53px;
        }
      }

      .applicat-search-items {
        padding: 20px 30px;

        .search-item {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }

  .search-label {
    width: 140px;
  }

  .search {
    flex-direction: column;
    line-height: 24px;
  }

  .title-no {
    flex-direction: row;
    display: flex;

    .title-no-left {
      width: 80%;
    }

    .title-no-right {
      width: 20%;
    }

    .reback {
      border: 4px solid red;
      color: red;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      font: 20px Arial, sans-serif;
      justify-content: center;
      align-items: center;
      text-align: center;
      display: flex;
    }
  }

  .fileList {
    width: 50%;
    display: flex;
    flex-direction: column;

    .fileList-item {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: center;

      .fileList-itemText {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
      }
    }
  }

  .kong-btn {
    width: 64px;
    margin-left: 10px;
  }

  .download-btn {
    display: inline-block;
    background-color: #5A9CFF;
    height: 24px;
    width: 64px;
    line-height: 23px;
    color: white;
    border-radius: 3px;
    font-size: 12px;
    margin-left: 10px;
    text-align: center;
    cursor: pointer;
  }

  .respondentInfo-box {
    max-height: 100px;
    display: flex;
    flex-wrap: wrap;
    line-height: 26px;
    overflow: auto;
  }

  .applyInform-box {
    margin-bottom: 15px;
    line-height: 23px;
  }

  .primary-btn {
    margin-left: 10px;
  }
}

// 确认撤回弹窗样式
.confirm-revoke-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      border-radius: 0!important;
    }
  }

  .dialog-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }

  .dialog-content {
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    padding: 30px 40px;
    .dialog-content-title{
      text-align: left;
    }
  }

  .dialog-footer {
    text-align: center;
  }
}
</style>
